module.exports = __webpack_public_path__ + "img/logovp3_40x40.18028599.svg";